import React from "react";
import { useTranslation } from "react-i18next";
export default function CompanyProfileSection() {
    const { t } = useTranslation();

    return (
        <section className="relative py-16">
            <div className="container px-4">
                <h2 className="text-4xl font-bold text-[#E56820] border-b-4 border-[#E56820] w-fit mb-6 mx-auto">
                    {t("Company Profile")}
                </h2>
                <div className="relative w-full h-[800px] rounded-lg overflow-hidden shadow-lg">
                    <iframe
                        src="https://alburoujplast.com/شركة%20حضارة%20البروج%20للصناعات%20البلاستيكية.pdf#toolbar=0"
                        title={t("company profile")}
                        className="w-full h-full"
                        allowFullScreen
                    ></iframe>

                </div>
            </div>
        </section>
    );
}